import { NAME } from "./constants";

const select = key => state => state.pages[NAME][key];

export const isLoading = select("isLoading");
export const getRecentCustomers = select("customers")
export const getCustomerSearchResults = select("searchResults");
